module.exports = "/packs/images/homepage/activity/gymnastic_desktop~bed882247d51080f6cf189835b613b6d.jpg";